import { InventoryRequest } from 'app/graphql/generated/admin/graphql';
import { DataTable } from 'components/ui/data-table';

import { columns } from './columns';

interface Props {
  list: InventoryRequest[];
  loading: boolean;
}

const InventoryRequestsTable = ({ list, loading }: Props) => (
  <DataTable
    columns={columns}
    data={list}
    loading={loading}
    pageSize={10}
    hideToolbar
    emptyState={<i>Nothing here yet</i>}
  />
);

export default InventoryRequestsTable;
